//IP1——大屏连接地址   IP——其他业务接口连接地址
// const IP = process.env.API_BASE_URL || ''
// const IP1 = process.env.SCREEN_BASE_URL || ''
const IP = 'https://yx.huayiyun.net:8080'
const IP1 = 'https://yx.huayiyun.net:8080'

//接口
const domain = {
    rouse: IP + '/yingxiang/rouse',//唤醒
    getImageCode: IP + '/yingxiang/getImageCode',//获取图形验证码
    getImgCodeState: IP + '/yingxiang/getImgCodeState',//验证码是否验证标志
    getLoginCode: IP + '/yingxiang/getLoginCode',//获取手机登录验证码
    loginDB: IP + '/yingxiang/db/login',//登录等保

    //公共
    login: IP + '/yingxiang/login',//登录
    logout: IP + '/yingxiang/logout',//登出
    queryRoleList: IP + '/base/perm',//查询医生角色所有权限 
    caseModality: IP + '/base/caseModality',//查询影像类型
    getReadAndWriteOSS: IP + '/yingxiang/oss/getReadAndWriteOSS',//获取oss
    getVerificationCode: IP + '/yingxiang/getVerificationCode', //获取验证码
    getBackPassword: IP + '/yingxiang/getBackPassword', //重置密码
    //allDictInfo:IP+'/base/allDictInfo',//查询远程申请病例状态

    remoteStatus: IP + '/base/remoteStatus',//查询远程申请病例状态
    localDiagStatus: IP + '/base/localDiagStatus',//查询本地诊断状态
    remoteDiagStatus: IP + '/base/remoteDiagStatus',//查询远程诊断病例状态
    remoteStatusCheck: IP + '/base/remoteStatusCheck',//查询远程申请病例状态（下拉框）
    bodyParts: IP + '/base/bodyParts',//查询身体部位列表
    listStudyLibrary: IP + '/local/listDiagLibrary',//查询诊断知识库
    updateFirstLogin: IP + '/yingxiang/updateFirstLogin',//修改第一次登陆状态
    getOtp: IP + '/goeasy/getOtpKey',//获取appKey加密

    //个人
    getAllHosp: IP + '/yingxiang/getAllHosp',//获取用户所任职的医院
    getHospPerms: IP + '/yingxiang/getHospPerms',//获取用户在选择的医院的权限
    getUserInfo: IP + '/yingxiang/getUserInfo',//获取登录人个人登录信息
    modifyPassword: IP + '/yingxiang/userinfo/modifyPassword',//修改密码
    modifyPersonalInfomation: IP + '/yingxiang/userinfo/modifyPersonalInfomation',//修改保存个人信息

    //医院管理
    queryHosp: IP + '/admin/hosp/queryHospInfo',//获取医院信息
    updateHospInfo: IP + '/admin/hosp/updateHospInfo',//更新医院信息
    queryHospBalance: IP + '/hosp/charge/get',//获得医院账户信息
    listChildHosp: IP + '/admin/hosp/listChildHosp',//查询下级医院列表
    add: IP + '/recharge/add',//充值下单
    WeChat: IP + '/recharge/WeChat',//获取微信二维码
    confirm: IP + '/recharge/confirm',//确认付款
    listPayRecord: IP + '/recharge/listPayRecord',//获得交易记录

    //医生管理
    queryUserFromHosp: IP + '/admin/doctor/queryUserFromHosp',//查询医生列表
    judgeDocIsExist: IP + '/admin/doctor/judgeDocIsExist',//根据手机号查询医生
    openAccount: IP + '/admin/doctor/openAccount',//医生开户
    queryUser: IP + '/admin/doctor/queryUser',//根据userId查询用户信息
    updateUserInfo: IP + '/admin/doctor/updateUserInfo',//保存修改医生信息

    //本院病历
    remoteList: IP + '/remote/list',//远程申请列表查询
    remoteDetail: IP + '/remote/get',//查询远程申请病例详情
    getApply: IP + '/remote/getApply',//远程申请-申请-查看病例
    apply: IP + '/remote/apply',//远程申请-申请远程按钮点击
    savePatientInfo: IP + '/case/savePatientInfo',//确认病人基本信息
    storage: IP + '/remote/storage',//远程申请-暂存
    getHospInfoList: IP + '/hosp/getHospInfoList',//获取该医院的关联医院列表
    submit: IP + '/remote/submit',//远程申请-提交申请
    getOrder: IP + '/remote/getOrder',//远程申请-查询订单详情
    payment: IP + '/remote/payment',//远程申请-订单支付
    batchList: IP + '/remote/batchList',//批量申请-病例列表
    batchNext: IP + '/remote/next',//批量申请-完善病例下一步
    batchConfirm: IP + '/remote/confirm',//批量申请-确认申请
    batchDelete: IP + '/remote/batchDelete',//远程申请-批量删除
    list: IP + '/local/list',//查询本地诊断的全部母病历
    listStudyDiag: IP + '/local/listStudyDiag',//查询本地诊断病历的诊断记录
    diagCase: IP + '/local/diagCase',//本地诊断占有
    caseGiveUp: IP + '/local/caseGiveUp',//放弃诊断此病例
    caseSubmit: IP + '/local/caseSubmit',//病例提交诊断
    cancelApply: IP + '/remote/cancelApply',//取消申请

    //远程病历
    remoteDiagList: IP + '/remote/diag/list',//远程诊断-查询诊断列表
    startDiag: IP + '/remote/diag/start',//开始诊断
    diagGiveUp: IP + '/remote/diag/giveUp',//放弃诊断、审核
    reject: IP + '/remote/diag/reject',//驳回
    listDiaged: IP + '/remote/diag/listDiaged',//远程诊断-查询诊断完成列表
    endDiag: IP + '/remote/diag/end',//结束诊断
    listAudit: IP + '/remote/diag/listAudit',//获取待审核列表
    listAudited: IP + '/remote/diag/listAudited',//远程诊断-查询审核完成列表
    startAudit: IP + '/remote/diag/startAudit',//开始审核
    endAudit: IP + '/remote/diag/endAduit',//结束审核
    listAll: IP + '/remote/diag/listAll',//结束审核
    exportAll: IP + '/remote/diag/exportAll',//全院病例导出
    diagStorage: IP + '/remote/diag/storage',//暂存诊断
    //监控大屏
    countStatMonitoring: IP1 + '/statistics/countStatMonitoring',
    countApplyDoc: IP1 + '/statistics/countApplyDoc',//申请医生的统计
    countDiagDoc: IP1 + '/statistics/countDiagDoc',
    countAuditDoc: IP1 + '/statistics/countAuditDoc',
    countMonitoringDiagStudy: IP1 + '/statistics/countMonitoringDiagStudy',
    countByBodyparts: IP1 + '/statistics/countByBodyparts',
    countByYinYang: IP1 + '/statistics/countByYinYang',
    countByEmergRate: IP1 + '/statistics/countByEmergRate',
    countByPassRate: IP1 + '/statistics/countByPassRate',
    countByAge: IP1 + '/statistics/countByAge',
    countByDay: IP1 + '/statistics/countByDay',
    countDiagTime: IP1 + '/statistics/countDiagTime',
    changeReadStatus: IP + '/remote/changeReadStatus',
    // 诊断模板
    saveDocDiagLibrary: IP + '/local/saveDocDiagLibrary', //添加医生个人诊断模板
    deleteDocDiagLibrary: IP + '/local/deleteDocDiagLibrary', //删除医生个人诊断模板
    selectDocDiagLibrary: IP + '/local/listDocDiagLibrary', //查询医生个人诊断模板列表
    //收藏
    collect: IP + '/remote/diag/collect',//收藏
    cancelCollect: IP + '/remote/diag/cancelCollect',//取消收藏
    collectList: IP + '/remote/diag/collectList',//收藏列表
    //修改报告
    amendreport: IP + '/remote/diag/amend/report',

    // 修改密码
    forceModifyPassword: IP + '/yingxiang/modifyPasswordNew',//修改密码

    // 专家库管理
    expertList: IP + '/exper/manage/list', // 专家列表
    expertDelete: IP + '/exper/manage/delete', // 删除专家库信息 get请求 唯一id this.$ajax.get(this.$domain.rouse,this.searchForm)
    expertDetail: IP + '/exper/manage/getById', // 专家查询详情  get请求 唯一id this.$ajax.get(this.$domain.rouse,this.searchForm)
    expertUpdate: IP + '/exper/manage/updateInfo', // 专家库修改
    expertSave: IP + '/exper/manage/saveInfo', // 新增专家管理接口

    // 文件上传、下载
    uploadFile: IP + '/exper/manage/uploadFile', // 新增专家管理接口

    // 查询字典表
    listDicts: IP + '/base/listDicts', // 查询字典表

    // 医生排班（yxScheduling）
    queryDoctorList: IP + '/yxScheduling/queryDoctorList', // 查询医院医生列表
    saveScheduleInfo: IP + '/yxScheduling/saveInfo', // 新增排班
    queryScheduleInfo: IP + '/yxScheduling/queryInfo', // 查询排班详情
    deleteSchedule: IP + '/yxScheduling/delete', // 删除排班
    updateScheduleInfo: IP + '/yxScheduling/updateInfo', // 修改排班
    listSchedule: IP + '/yxScheduling/queryInfoList', // 分页查询排班列表
    // 会诊申请相关（cons/apply）
    consApplyList: IP + '/cons/apply/list', // 获取会诊申请列表 GET
    consApplyAdd: IP + '/cons/apply/add', // 发起会诊申请 POST
    consApplySendAgain: IP + '/cons/apply/sendAgain', // 再次申请会诊 POST
    consApplyCaseInfo: IP + '/cons/apply/caseInfo', // 查询会诊病例信息 GET
    consApplySuggestList: IP + '/cons/apply/suggestList', // 查看会诊建议列表 GET
    consApplyUserList: IP + '/cons/apply/userList', // 查询会诊专家列表 GET
    consApplyGetHospList: IP + '/cons/apply/getHospList', // 获取关联医院列表 GET
    consApplyConfirm: IP + '/cons/apply/confirm', // 会诊确认查询 GET
    consApplyAccept: IP + '/cons/apply/accept', // 会诊申请接收/拒绝 POST
    consApplyCancel: IP + '/cons/apply/cancel', // 下级取消会诊申请 POST
    // 会诊过程接口
    addCons: IP + '/cons/apply/addCons', // 加入会诊 POST
    endCons: IP + '/cons/apply/endCons', // 结束会诊 POST
    joinCons: IP + '/cons/apply/joinCons', // 填写建议 POST
    // 会诊记录（consRecord）
    consRecordList: IP + '/consRecord/list', // 查询会诊记录列表 GET
    consRecordQueryInfo: IP + '/consRecord/queryInfo', // 根据会诊ID查询会诊详情 GET
    consRecordGetLastDiagSubRecord: IP + '/consRecord/getLastDiagSubRecord', // 根据病例ID查询最近一次诊断子记录 GET
    // 基层会诊（grassroots）
    grassrootsHzList: IP + '/grassrootsHz/list', // 获取基层会诊列表 GET
    // 会诊日程管理（dates）
    consDatesList: IP + '/dates/list', // 查询会诊日程列表 GET/POST
    consDatesDetail: IP + '/dates/detail', // 查询会诊日程详情 GET/POST
    // 会诊审核（hzAudit）
    hzAuditList: IP + '/hzAudit/list', // 获取会诊审核列表 GET
    hzAuditDetail: IP + '/hzAudit/detail', // 获取会诊审核详情 GET
    hzAuditAudit: IP + '/hzAudit/audit', // 会诊审核提交 POST
    // 影像质控（quality）
    qualityList: IP + '/quality/list', // 影像质控列表 POST
    qualityMark: IP + '/quality/mark', // 标记质控类型 POST
    qualityGet: IP + '/quality/get', // 查询当前质控结果 GET
    }
    export default domain












// WEBPACK FOOTER //
// ./src/service/getData.js